module.exports = function(bh) {
    bh.match('navigation-panel__item', function(ctx, json) {
        ctx.tParam('ID', ctx.generateId(), true);
    });
};
